const TOOLTIP = {
    onReady() {
        let tips = document.querySelectorAll('.js-tooltip');
        tips.forEach(tip => {
            tip.addEventListener('click', event => {
                event.preventDefault(); 
                TOOLTIP.getContent({tip: tip});
            });
        });
    },
    getContent({tip}) {
        let xhr, responseText;
        (window.XMLHttpRequest) && (xhr = new XMLHttpRequest());
        xhr.onreadystatechange = () => {
            (xhr.readyState === 4 && xhr.status === 200) && (TOOLTIP.build({tip: tip, html: xhr.responseText}));
        }
        xhr.open('GET', tip.href, true );
        xhr.send();
    },
    build({tip, html}) {
        let hrefArr     = tip.href.split("/"); // ['https:', '', 'www.andreagrundmann.de', 'knowhow-blog', 'online-marketing-basics', 'lead', '']
        let id          = 'tooltip-' + hrefArr[hrefArr.length - 2]; // 'lead'
        if (document.getElementById(id) === null) {
            let mainContent = html.match(/(?=<main>).*?(<\/main>)/gs);
            let markup      = `<div class="overlay--tooltip" id="${id}">
                                   <div class='overlay__close' onclick='OVERLAY.close(this)' >
                                       <img src='dist/img/icons/icon--close.svg'/>
                                   </div>
                                   ${mainContent}
                               </div>`;
            document.body.insertAdjacentHTML('afterbegin', markup);
        } else {
            document.getElementById(id).style.display = 'block';
        }
        document.body.classList.add('noscroll');
    }
}